import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { QuickViewComponent } from "../../modal/quick-view/quick-view.component";
import { CartModalComponent } from "../../modal/cart-modal/cart-modal.component";
import { Product } from "../../../classes/product";
import { ProductService } from "../../../services/product.service";
import { GoogleAnalyticsService } from '../../../../shared/services/google-analytics.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-product-box-one',
  templateUrl: './product-box-one.component.html',
  styleUrls: ['./product-box-one.component.scss']
})
export class ProductBoxOneComponent implements OnInit {

  @Input() product: Product;
  @Input() currency: any = this.productService.Currency; // Default Currency 
  @Input() thumbnail: boolean = false; // Default False 
  @Input() onHowerChangeImage: boolean = false; // Default False
  @Input() cartModal: boolean = false; // Default False
  @Input() loader: boolean = false;
  
  @ViewChild("quickView") QuickView: QuickViewComponent;
  @ViewChild("cartModal") CartModal: CartModalComponent;

  public ImageSrc : string
  public userName: any;

  constructor(private productService: ProductService, private route: ActivatedRoute,
    private analytics: GoogleAnalyticsService) {
      
  }

  ngOnInit(): void {
    this.userName = JSON.parse(sessionStorage.getItem("user"))?.userName || 'invitado@GIGMAX.com';    
    
    if(this.loader) {
      setTimeout(() => { this.loader = false; }, 2000); // Skeleton Loader
    }

    if (this.product && this.product.discount != null) {
      this.product.discount = Math.trunc(this.product.discount);
    }
  }

  // Get Product Color
  Color(variants) {
    const uniqColor = [];
  
    // Verificar que variants no sea null ni undefined y sea un array
    if (Array.isArray(variants)) {
      for (let i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].color && uniqColor.indexOf(variants[i].color) === -1) {
          uniqColor.push(variants[i].color);
        }
      }
    }
  
    return uniqColor;
  }
  

  // Change Variants
  ChangeVariants(color, product) {
    product.variants.map((item) => {
      if (item.color === color) {
        product.images.map((img) => {
          if (img.image_id === item.image_id) {
            this.ImageSrc = img.src;
          }
        })
      }
    })
  }

  // Change Variants Image
  ChangeVariantsImage(src) {
    this.ImageSrc = src;
  }

  getProveedorColorClass(): string {
    switch (this.product.productoProveedor) {
      case 'Fulfil':
        return 'tag-fulfil';
      case 'FRDX':
        return 'tag-frdx';
      case 'AntenaBay':
        return 'tag-antenabay';
      default:
        return '';
    }
  }
  

  addToCart(product: any) {
    this.productService.addToCart(product);
    this.analytics.sendEvent('add_to_cart', {
      idEvento: 4,
      currency: 'MXN',
      userName: this.userName,
      value: product.price,
      items: [
        {
          item_name: product.title,
          item_id: product.id,
          price: product.price,
          quantity: 1,
        },
      ],
    });
  }

  addToWishlist(product: any) {
    this.productService.addToWishlist(product);
  }

  addToCompare(product: any) {
    this.productService.addToCompare(product);
  }

}
